import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

const AsyncReviewPageContainer = Load(
  () =>
    import(
      /* webpackChunkName: "review-page" */ './containers/ReviewPageContainer'
    ),
);

export const hostReviewPageRoute: RouteDescriptor = {
  id: 'host.review-page',
  path: `${basePath}/host/review/:reviewId/`,
  label: 'Host Review Page',
  audience: 'host',
  layout: 'standalone',
  module: 'review-page',
};

export const reviewPageRoutes = [
  <Route
    key={hostReviewPageRoute.id}
    id={hostReviewPageRoute.id}
    path={hostReviewPageRoute.path}
    handle={createRouteHandle(hostReviewPageRoute)}
    element={<AsyncReviewPageContainer />}
  />,
];

export const reviewPageRouteDescriptors = [hostReviewPageRoute];

export default reviewPageRoutes;
